export default __webpack_public_path__ + "static/media/icon5.a07b19b2.svg";